import SequencePositionEnum = Meevo.Model.SequencePositionEnum;

module Meevo.Components.Controls {
    export class MeevoDefinitionSchedule implements angular.IDirective {
        restrict = "E";
        require = '^form';
        scope = {
            context: "=",
            showEndTime: "=",
            canBePerpetual: "@",
            tabIndex: "=?",
            isBlockDef: "@?",
            maxIntervals: "=?",
            maxMinutes: "=?",
            standingBlock:"=",
            allowDefiningStartTimesManually: "=?",
        }

        templateUrl = "app/components/controls/definitionScheduleTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, form: any) => {

            interface StandingFrequency {
                id: Meevo.Model.DateTimeUnitEnum;
                displayName: string;
            }

            const daysRef = {
                0: this.$translate.instant("LABEL_SUNDAY"),
                1: this.$translate.instant("LABEL_MONDAY"),
                2: this.$translate.instant("LABEL_TUESDAY"),
                3: this.$translate.instant("LABEL_WEDNESDAY"),
                4: this.$translate.instant("LABEL_THURSDAY"),
                5: this.$translate.instant("LABEL_FRIDAY"),
                6: this.$translate.instant("LABEL_SATURDAY")
            }

            let days = [];
            for (var i = 1; i <= 31; i++) {
                days.push(i);
            }
            scope.days = days;
            
            if (!scope.maxIntervals) {
                // preserve default
                scope.maxIntervals = 32;
            }
 
            scope.frequencyUnitReferenceData = [
                { id: Meevo.Model.DateTimeUnitEnum.Day, displayName: this.$translate.instant("LABEL_DAILY"), counterName: this.$translate.instant("LABEL_DAYS") },
                { id: Meevo.Model.DateTimeUnitEnum.Week, displayName: this.$translate.instant("LABEL_WEEKLY"), counterName: this.$translate.instant("LABEL_WEEKS") },
                { id: Meevo.Model.DateTimeUnitEnum.Month, displayName: this.$translate.instant("LABEL_MONTHLY"), counterName: this.$translate.instant("LABEL_MONTHS") }
            ];

            scope.form = form;

            scope.$watch("context.selectedSection.model", function () {

                if (!scope.context.selectedSection.model) {
                    return;
                }

                if (!scope.selectedFrequency || (scope.selectedFrequency && scope.context.selectedSection.model.frequencyUnit && scope.context.selectedSection.model.frequencyUnit !== scope.selectedFrequency.id)) {
                    scope.selectedFrequency = getStandingFrequency(scope.context.selectedSection.model.frequencyUnit);
                }

                if (!scope.selectedWeekOccurrence) scope.setWeekOccurrence()

                generateDaysList();

                validate();

            }, true);

            function validate() {
                var isInvalid =
                    (+scope.context.selectedSection.model.frequencyUnit === Meevo.Model.DateTimeUnitEnum.Week ||
                    (+scope.context.selectedSection.model.frequencyUnit === Meevo.Model.DateTimeUnitEnum.Month &&
                    scope.context.selectedSection.monthlyChoice === scope.context.selectedSection.dayOfWeekChoice)) &&
                    scope.context.selectedSection.model.daysOfWeek.length === 0;

                if (form.daysOfWeek) {
                    form.daysOfWeek.$setValidity("required", !isInvalid);
                }
            }

            function getStandingFrequency(frequencyId: number) {
                let frequency: StandingFrequency = _.find(scope.frequencyUnitReferenceData, (item: StandingFrequency) => {
                    return Number(item.id) === Number(frequencyId);
                })
                return frequency;
            }

            function generateDaysList() {
                scope.selectedDaysList = '';
                if (scope.context.selectedSection.model.daysOfWeek) {
                    _.each(scope.context.selectedSection.model.daysOfWeek.sort(), (day: number, index) => {
                        scope.selectedDaysList += daysRef[day]
                        if (index !== scope.context.selectedSection.model.daysOfWeek.length - 1) {
                            scope.selectedDaysList += ', ';
                        }
                    })
                };

                return scope.selectedDaysList;
            }

            scope.numberOfOccurrencesChoiceChosen = function () {
                if (!scope.context.isReadonly) {
                    scope.context.selectedSection.model.totalOccurrences = scope.context.selectedSection.defaultTotalOccurrences;
                    scope.context.selectedSection.model.endDate = undefined;
                    scope.context.selectedSection.model.isPerpetual = false;
                }
            }

            scope.endByChoiceChosen = function () {
                if (!scope.context.isReadonly) {
                    scope.context.selectedSection.model.totalOccurrences = undefined;
                    scope.context.selectedSection.model.endDate = scope.context.selectedSection.model.startDate || scope.context.selectedSection.defaultEndDate;
                    scope.context.selectedSection.model.isPerpetual = false;
                }
            }

            scope.isPerpetualChoiceChosen = () => {
                if (!scope.context.isReadonly) {
                    scope.context.selectedSection.model.totalOccurrences = undefined;
                    scope.context.selectedSection.model.endDate = undefined;
                    scope.context.selectedSection.model.isPerpetual = true;
                }
            }

            scope.dayOfWeekChoiceChosen = function () {
                if (!scope.context.isReadonly) {
                    scope.context.selectedSection.model.occurrenceInInterval = scope.context.selectedSection.defaultOccurrenceInterval;
                    scope.context.selectedSection.model.dayOfMonth = undefined;
                }
            }

            scope.dayOfMonthChoiceChosen = function () {
                if (!scope.context.isReadonly) {
                    scope.context.selectedSection.model.occurrenceInInterval = undefined;
                    scope.context.selectedSection.model.dayOfMonth = scope.context.selectedSection.defaultDayOfMonth;
                    scope.context.selectedSection.model.daysOfWeek = [];
                }
            }

            scope.frequencyUnitChanged = function () {
                if (scope.context.selectedSection.model.frequencyUnit == Meevo.Model.DateTimeUnitEnum.Day) {
                    scope.context.selectedSection.model.daysOfWeek = [];
                }
                if (scope.context.selectedSection.model.frequencyUnit != Meevo.Model.DateTimeUnitEnum.Month) {
                    scope.context.selectedSection.model.dayOfMonth = undefined;
                }
            }

            scope.getWeekOccurrence = () => {
                const intervalType: SequencePositionEnum = scope.context.selectedSection.model.occurrenceInInterval;
                switch (intervalType) {
                    case 14: return this.$translate.instant("LABEL_FIRST");
                    case 15: return this.$translate.instant("LABEL_SECOND");
                    case 17: return this.$translate.instant("LABEL_THIRD");
                    case 18: return this.$translate.instant("LABEL_FOURTH");
                    case 16: return this.$translate.instant("LABEL_LAST");
                }
            }

            scope.setWeekOccurrence = () => {
                scope.selectedWeekOccurrence = scope.getWeekOccurrence();
            }

            scope.isFrequencyLockedFromEdit = () => {
                return scope.context.selectedSection.model && scope.context.selectedSection.model.hasScheduleStarted && scope.context.selectedSection.endingChoice === scope.context.selectedSection.numberOfOccurrencesChoice
            }
        }

        constructor(private $translate: angular.translate.ITranslateService) {

        }


        static factory(): angular.IDirectiveFactory {
            let directive = ($translate) => {
                return new MeevoDefinitionSchedule($translate);
            }

            directive.$inject = ["$translate"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoDefinitionSchedule", MeevoDefinitionSchedule.factory());
}